 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","branches":"branches","branding":"branding","channel-factor":"channel-factor","dashboard-activity~dashboard-reporting~system-logs":"dashboard-activity~dashboard-reporting~system-logs","dashboard-reporting":"dashboard-reporting","access":"access","account-info":"account-info","additional-info":"additional-info","finish":"finish","public-registration-account-info":"public-registration-account-info","public-registration-setup-profile":"public-registration-setup-profile","public-registration-upload-document":"public-registration-upload-document","setup-profile":"setup-profile","public-registration-record-video~upload-document":"public-registration-record-video~upload-document","public-registration-record-video":"public-registration-record-video","upload-document":"upload-document","system-users":"system-users","view-alerts":"view-alerts","dashboard-activity":"dashboard-activity","system-logs":"system-logs","configuration":"configuration","contact-us":"contact-us","country":"country","country-type":"country-type","customer":"customer","data-type":"data-type","deceased":"deceased","descprition-1":"descprition-1","descprition-2":"descprition-2","descprition-3":"descprition-3","document-verification-factor":"document-verification-factor","forgot-password":"forgot-password","gender":"gender","idenfo-engine":"idenfo-engine","identification":"identification","industry":"industry","login":"login","name-screen-score":"name-screen-score","name-type":"name-type","nationality":"nationality","occupation":"occupation","on-boarding-configuration":"on-boarding-configuration","productFactor":"productFactor","public-register-customer":"public-register-customer","public-ssa-customer":"public-ssa-customer","purpose-of-action":"purpose-of-action","record-status":"record-status","register-customer":"register-customer","relationship-factor":"relationship-factor","relationship-type":"relationship-type","reset-password":"reset-password","risk-factor":"risk-factor","risk-level-review":"risk-level-review","risk-rating":"risk-rating","role-type":"role-type","roles":"roles","sanction-reference":"sanction-reference","screening-data":"screening-data","simulate":"simulate","ssa-customer":"ssa-customer","state":"state","work":"work","world-check-EIType":"world-check-EIType","world-check-category":"world-check-category","world-check-deceased":"world-check-deceased","world-check-keyword":"world-check-keyword","world-check-location":"world-check-location","world-check-sub-category":"world-check-sub-category","world-check-update-category":"world-check-update-category"}[chunkId]||chunkId) + "." + {"404":"abe8ef2f","branches":"29ce909a","branding":"f634f15a","channel-factor":"355999dc","chunk-1acbbf1c":"92f18715","chunk-20bef806":"3d6aebc1","chunk-2228a6de":"a6290979","chunk-2b81102a":"5cfd54c6","dashboard-activity~dashboard-reporting~system-logs":"2e204742","dashboard-reporting":"ab2fa537","chunk-2d0a2dd2":"b78d7a73","chunk-2d0a34dd":"56142a0c","chunk-2d0bd416":"e57255ff","chunk-2d0cbf12":"5948e21e","chunk-2d0e97b4":"10a5be69","access":"3a19ee1c","chunk-2d22fd71":"9ada0df9","chunk-301c3905":"7dcc35f4","chunk-23a4445d":"6d05c065","account-info":"488c21a7","additional-info":"d248a16c","finish":"b7d6c604","public-registration-account-info":"50dd9130","public-registration-setup-profile":"c5e03623","public-registration-upload-document":"2ab953d0","setup-profile":"160f403b","chunk-76fde123":"372bfef8","chunk-9f1a0944":"52e9d949","public-registration-record-video~upload-document":"1d3468af","public-registration-record-video":"dc06221c","upload-document":"64f476c8","system-users":"71ff6d58","chunk-062c837c":"ab913242","chunk-2d0dd7ae":"4f75b828","view-alerts":"c49152aa","dashboard-activity":"22e75bfc","system-logs":"91d4b87c","chunk-2d2384d6":"08a4e07e","chunk-237f61fb":"d836f775","chunk-326bdc82":"902caa4f","chunk-326f5bbf":"72d08e1a","chunk-32bc38d4":"7277186f","chunk-0b25d612":"55b0d84d","chunk-910149de":"b20afc65","chunk-f150845c":"30731055","chunk-607e77cd":"84790f05","chunk-4b95809e":"0f34486e","chunk-069e1352":"058b9388","chunk-19357db2":"2bc3c320","chunk-2d0b99a6":"68231a5c","chunk-37ded23c":"a311fc05","chunk-40c60f82":"11a9492a","chunk-73605f7d":"3f11a95e","chunk-b5536b38":"caf99515","chunk-c543a044":"458f570b","configuration":"e19f093c","contact-us":"486ef2de","country":"fe55f34f","country-type":"6985eeda","customer":"ed178000","data-type":"ea9e9672","deceased":"1ed20349","descprition-1":"4a385b49","descprition-2":"0f2b7ea1","descprition-3":"47cf4aab","document-verification-factor":"b3992455","forgot-password":"7263aec7","gender":"b3bafba3","idenfo-engine":"a54b223f","identification":"8c10b47d","industry":"4b14f8c4","login":"9020981f","name-screen-score":"56bcc49c","name-type":"2de95cb6","nationality":"e33f55a0","occupation":"d8d7de01","on-boarding-configuration":"f52bac6d","productFactor":"5d3fb4e6","public-register-customer":"e15834e8","public-ssa-customer":"481d4094","purpose-of-action":"28cbb94f","record-status":"d7f721c0","register-customer":"6f49f354","relationship-factor":"84f2df4b","relationship-type":"1cd4bbd2","reset-password":"0859eb79","risk-factor":"1d05d320","risk-level-review":"9930a32c","risk-rating":"857feae1","role-type":"3e741bc9","roles":"689a0279","sanction-reference":"cd7bd70f","screening-data":"009d26bc","simulate":"d3c9f820","ssa-customer":"0f1bc3c5","state":"b26d99fd","work":"bbd7cf39","world-check-EIType":"851d0d66","world-check-category":"19803754","world-check-deceased":"f0ee11fb","world-check-keyword":"309e7802","world-check-location":"2e7ebcd1","world-check-sub-category":"7a6be12e","world-check-update-category":"31e8b473"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-1acbbf1c":1,"chunk-20bef806":1,"chunk-2228a6de":1,"account-info":1,"additional-info":1,"finish":1,"public-registration-account-info":1,"public-registration-setup-profile":1,"public-registration-upload-document":1,"setup-profile":1,"chunk-76fde123":1,"public-registration-record-video~upload-document":1,"public-registration-record-video":1,"upload-document":1,"chunk-062c837c":1,"chunk-32bc38d4":1,"chunk-0b25d612":1,"chunk-910149de":1,"chunk-f150845c":1,"chunk-19357db2":1,"chunk-37ded23c":1,"chunk-c543a044":1,"industry":1,"register-customer":1,"ssa-customer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","branches":"branches","branding":"branding","channel-factor":"channel-factor","dashboard-activity~dashboard-reporting~system-logs":"dashboard-activity~dashboard-reporting~system-logs","dashboard-reporting":"dashboard-reporting","access":"access","account-info":"account-info","additional-info":"additional-info","finish":"finish","public-registration-account-info":"public-registration-account-info","public-registration-setup-profile":"public-registration-setup-profile","public-registration-upload-document":"public-registration-upload-document","setup-profile":"setup-profile","public-registration-record-video~upload-document":"public-registration-record-video~upload-document","public-registration-record-video":"public-registration-record-video","upload-document":"upload-document","system-users":"system-users","view-alerts":"view-alerts","dashboard-activity":"dashboard-activity","system-logs":"system-logs","configuration":"configuration","contact-us":"contact-us","country":"country","country-type":"country-type","customer":"customer","data-type":"data-type","deceased":"deceased","descprition-1":"descprition-1","descprition-2":"descprition-2","descprition-3":"descprition-3","document-verification-factor":"document-verification-factor","forgot-password":"forgot-password","gender":"gender","idenfo-engine":"idenfo-engine","identification":"identification","industry":"industry","login":"login","name-screen-score":"name-screen-score","name-type":"name-type","nationality":"nationality","occupation":"occupation","on-boarding-configuration":"on-boarding-configuration","productFactor":"productFactor","public-register-customer":"public-register-customer","public-ssa-customer":"public-ssa-customer","purpose-of-action":"purpose-of-action","record-status":"record-status","register-customer":"register-customer","relationship-factor":"relationship-factor","relationship-type":"relationship-type","reset-password":"reset-password","risk-factor":"risk-factor","risk-level-review":"risk-level-review","risk-rating":"risk-rating","role-type":"role-type","roles":"roles","sanction-reference":"sanction-reference","screening-data":"screening-data","simulate":"simulate","ssa-customer":"ssa-customer","state":"state","work":"work","world-check-EIType":"world-check-EIType","world-check-category":"world-check-category","world-check-deceased":"world-check-deceased","world-check-keyword":"world-check-keyword","world-check-location":"world-check-location","world-check-sub-category":"world-check-sub-category","world-check-update-category":"world-check-update-category"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","branches":"31d6cfe0","branding":"31d6cfe0","channel-factor":"31d6cfe0","chunk-1acbbf1c":"f3de5b15","chunk-20bef806":"5581a8b6","chunk-2228a6de":"7dfb08f7","chunk-2b81102a":"31d6cfe0","dashboard-activity~dashboard-reporting~system-logs":"31d6cfe0","dashboard-reporting":"31d6cfe0","chunk-2d0a2dd2":"31d6cfe0","chunk-2d0a34dd":"31d6cfe0","chunk-2d0bd416":"31d6cfe0","chunk-2d0cbf12":"31d6cfe0","chunk-2d0e97b4":"31d6cfe0","access":"31d6cfe0","chunk-2d22fd71":"31d6cfe0","chunk-301c3905":"31d6cfe0","chunk-23a4445d":"31d6cfe0","account-info":"a1f41251","additional-info":"bb5a6e3b","finish":"c04e6959","public-registration-account-info":"73886f19","public-registration-setup-profile":"73886f19","public-registration-upload-document":"937086b8","setup-profile":"02661c86","chunk-76fde123":"5557fef5","chunk-9f1a0944":"31d6cfe0","public-registration-record-video~upload-document":"7a51f55c","public-registration-record-video":"1c4657a4","upload-document":"14973af6","system-users":"31d6cfe0","chunk-062c837c":"48adc48f","chunk-2d0dd7ae":"31d6cfe0","view-alerts":"31d6cfe0","dashboard-activity":"31d6cfe0","system-logs":"31d6cfe0","chunk-2d2384d6":"31d6cfe0","chunk-237f61fb":"31d6cfe0","chunk-326bdc82":"31d6cfe0","chunk-326f5bbf":"31d6cfe0","chunk-32bc38d4":"16b99180","chunk-0b25d612":"1087b6a3","chunk-910149de":"1087b6a3","chunk-f150845c":"db943fdd","chunk-607e77cd":"31d6cfe0","chunk-4b95809e":"31d6cfe0","chunk-069e1352":"31d6cfe0","chunk-19357db2":"0e136c73","chunk-2d0b99a6":"31d6cfe0","chunk-37ded23c":"e935173d","chunk-40c60f82":"31d6cfe0","chunk-73605f7d":"31d6cfe0","chunk-b5536b38":"31d6cfe0","chunk-c543a044":"88f0feac","configuration":"31d6cfe0","contact-us":"31d6cfe0","country":"31d6cfe0","country-type":"31d6cfe0","customer":"31d6cfe0","data-type":"31d6cfe0","deceased":"31d6cfe0","descprition-1":"31d6cfe0","descprition-2":"31d6cfe0","descprition-3":"31d6cfe0","document-verification-factor":"31d6cfe0","forgot-password":"31d6cfe0","gender":"31d6cfe0","idenfo-engine":"31d6cfe0","identification":"31d6cfe0","industry":"b8c388fb","login":"31d6cfe0","name-screen-score":"31d6cfe0","name-type":"31d6cfe0","nationality":"31d6cfe0","occupation":"31d6cfe0","on-boarding-configuration":"31d6cfe0","productFactor":"31d6cfe0","public-register-customer":"31d6cfe0","public-ssa-customer":"31d6cfe0","purpose-of-action":"31d6cfe0","record-status":"31d6cfe0","register-customer":"73886f19","relationship-factor":"31d6cfe0","relationship-type":"31d6cfe0","reset-password":"31d6cfe0","risk-factor":"31d6cfe0","risk-level-review":"31d6cfe0","risk-rating":"31d6cfe0","role-type":"31d6cfe0","roles":"31d6cfe0","sanction-reference":"31d6cfe0","screening-data":"31d6cfe0","simulate":"31d6cfe0","ssa-customer":"73886f19","state":"31d6cfe0","work":"31d6cfe0","world-check-EIType":"31d6cfe0","world-check-category":"31d6cfe0","world-check-deceased":"31d6cfe0","world-check-keyword":"31d6cfe0","world-check-location":"31d6cfe0","world-check-sub-category":"31d6cfe0","world-check-update-category":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
